import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import ABanner from './components/A';
import BIcons from './components/B';
import CSection from './components/C';
import DSection from './components/D';
import { EOther } from './components/E';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function XBoostPC() {
    if (typeof window !== 'undefined') {
        (window as any).ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap((window as any).ScrollMagic, TweenMax, TimelineMax);
    }
    return (
        <div className={`xboost ${css.xboost}`}>
            <div className="ani-box">
                <div className="first">
                    <div className="first_1">
                        <ABanner />
                    </div>
                    <div className="first_2">
                        <BIcons />
                    </div>
                </div>
            </div>
            <CSection />
            <DSection />
            <EOther />
        </div>
    );
}
